import { stateOffer } from 'consts/data';

export const checkTypeOffer = (campaign) => {
  const { domainGroups, offers } = campaign;

  if (offers && offers.length > 0) {
    return stateOffer.OFFER;
  }

  if (domainGroups && domainGroups.length > 0) {
    return stateOffer.PREFILL_OFFER;
  }

  return stateOffer.NO_OFFER;
};
